import {api} from "./api.service";

export class PillarsService {
    static async getPillars() {
        return api.get("pillar");
    }
    static async getSinglePillar(id) {
        return api.get(`pillar-history/${id}`);
    }
    static async getCurrentDatPillars() {
        return api.get("pillar-history/current-day");
    }
    static async deleteArchivePillars(id) {
        return api.delete(`pillar-history/delete-archieve/${id}`);
    }
    static async updateCurrentDatePillars(id, data) {
        return api.patch(`pillar-history/${id}`, data);
    }
    static async getArchivePillars(fromDate, toDate , sort ='createdAt' , order = 'desc') {

        const params = {}
        if(fromDate)
            params['fromDate'] = fromDate
        if(toDate)
            params['toDate'] = toDate
        if(sort)
            params['sort'] = sort
        if(order)
            params['order'] = order


        return api.get("pillar-history/archive", {params});

    }
}



